import { render } from "./FilesTable.vue?vue&type=template&id=7cf1cca4"
import script from "./FilesTable.vue?vue&type=script&lang=js"
export * from "./FilesTable.vue?vue&type=script&lang=js"

import "./FilesTable.vue?vue&type=style&index=0&id=7cf1cca4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__